<div class="row">
    <div class="col-lg-12">

        <div class="row mt-2">
            <div class="col-lg-3">
                <div class="col-lg-12">
                    <label style="font-weight:bold">Show Status<sup class="super-script">*</sup> </label>
                </div>
                <div class="col-lg-12">
                    <select class="d-inline-flex w-100 form-control " 
                   [(ngModel)]="FS" (ngModelChange)="getSFTPFilter()">
                      <option [value]=sl.Key *ngFor="let sl of FilterStatusList">{{sl.Value}}
                      </option>
                    </select>   
                </div>
            </div>
            <div class="col-lg-6">
                <div class="col-lg-12">
                    <label style="font-weight:bold"> </label>
                </div>
                <div class="col-lg-12">
                     
                </div>
            </div>
            <div class="col-lg-3">
                <div class="col-lg-12">
                    <label style="font-weight:bold"></label>
                </div>
                <div class="col-lg-12 mt-2">
                    <button class="btn blue-btn " style="float: right;" data-bs-toggle="modal" data-bs-target="#CreateorUpdateSFTPModal">
                        Add SFTP</button>&nbsp;&nbsp;
                </div>
            </div>
        </div>
        
    </div>
</div>
<!-- ejs-grid -->
<div class="row">
    <div class="col-lg-12">
        <ejs-grid #gridsftp [dataSource]='SFTPDataGridList | async' [allowResizing]='true' [allowSorting]='true'
            allowPaging='true' [allowFiltering]='true' (actionBegin)="onActionCompleteSFTP($event);"
            [pageSettings]='initialPage' [filterSettings]='filterSettings' 
            (dataStateChange)='dataStateChangeSFTP($event)' [showColumnChooser]='true'>
            <e-columns>
                <e-column headerText="Actions" uid="action" textAlign="center" [allowFiltering]="false"
                    [showInColumnChooser]='false' minWidth=100>
                    <ng-template #template let-data>
                        <button class="btn btn-edit-table me-3" (click)="getDetails(data)" data-bs-toggle="modal"
                            data-bs-target="#CreateorUpdateSFTPModal"><i class="fa fa-edit"></i></button>
                        <button data-bs-target="#deletemodal" data-bs-toggle="modal" class="btn btn-delete-table"
                            (click)="getDeleteList(data)">
                            <i class="fa fa-trash fa-lg"></i></button>
                    </ng-template>
                </e-column>
                <!-- Company Name -->
                <e-column field="username" headerText="User Name" minWidth=100 type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column field="email" headerText="Email" minWidth=100 type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column field="isActive" headerText="Status" minWidth=100 type='string' [allowSorting]='false' allowPaging='false'
                    [allowFiltering]='true'>
                    <ng-template #template let-data>
                        {{ data.isActive ? 'ACTIVE' : 'INACTIVE' }}
                    </ng-template>
                </e-column>


                <!-- <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                        <div>
                            <span id='show' (click)='showAggregator()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                </i></span>
                        </div>
                    </ng-template>
                </e-column> -->
            </e-columns>
        </ejs-grid>
        <div *ngIf="SFTPData.length==0 && global.globalAgencyId != 0 " class="text-center" style="color:red">
            <p>No data available</p>
        </div>
    </div>
</div>
<!-- for Create SFTP -->
<span id="openCreateorUpdateSFTP" data-bs-toggle="modal" data-bs-target="#CreateorUpdateSFTPModal"></span>
<div class="modal hide fade modalbackgrod" id="CreateorUpdateSFTPModal" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"
                    *ngIf="SFTPForm.value.id=='00000000-0000-0000-0000-000000000000'">Create
                    SFTP</h5>
                <h5 class=" modal-title font-header" id="exampleModalLabel"
                    *ngIf="SFTPForm.value.id!='00000000-0000-0000-0000-000000000000'">Update
                    SFTP</h5>
                <button type=" button" class="btn-close" (click)="clearField()"></button>
            </div>
            <div class="modal-body" [formGroup]="SFTPForm">
                <div class="row">
                    <div class="col-lg-12 mt-1">
                        <label style="font-weight:bold">Status<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-12 mt-1" >
                        <select class="d-inline-flex w-100 form-control " 
                        formControlName="isActive" >
                          <option [value]=sl.Key *ngFor="let sl of StatusList">{{sl.Value}}
                          </option>
                        </select>   
                    </div>
                    
                </div>
                <!-- Name -->
                <div class="row mt-1">
                    <div class="col-lg-12 mt-1">
                        <label style="font-weight:bold">User Name<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-12 mt-1" *ngIf="SFTPForm.value.id=='00000000-0000-0000-0000-000000000000'">
                        <input class=" form-control" type="string" formControlName="userName" />
                    </div>
                    <div class="col-lg-12 mt-1" *ngIf="SFTPForm.value.id!='00000000-0000-0000-0000-000000000000'">
                        <input class=" form-control" type="string" formControlName="userName" disabled />
                    </div>
                </div>
                <!--Password -->
                <div class="row mt-1">
                    <div class="col-lg-12 mt-1">
                        <label style="font-weight:bold">Password<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-12 mt-1">
                        <input class="form-control" type="password" formControlName="Password"  />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-12 mt-1">
                        <label style="font-weight:bold">Email</label>
                    </div>
                    <div class="col-lg-12 mt-1">
                        <input class="form-control" type="email" formControlName="Email"  />
                    </div>
                </div>
                   <!-- <small class="text-danger" *ngIf="SFTPForm.get('Password').touched">
                            <span *ngIf="SFTPForm.get('Password').hasError('required')">Password is
                                required</span>
                            <span *ngIf="SFTPForm.get('Password').hasError('invalidPassword')">Password
                                isn't long enough, minimum of 8 characters</span>
                        </small> -->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="SaveorUpdateSFTP()"
                    [disabled]="!SFTPForm.valid">
                    <span *ngIf="SFTPForm.value.id=='00000000-0000-0000-0000-000000000000'">Save & Close</span>
                    <span *ngIf="SFTPForm.value.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span>

                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="clearField()">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="closeModal" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" (click)="CancelDelete()" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteSFTPCredentials()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="CancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>